<template>
  <div class="asc-create-plot-wrapper" data-automation-id="wrapper_create_plot">
    <asc-accent-button
      button-text="CREATE NEW PLOT"
      icon="mdi-plus"
      icon-position="left"
      secondary
      :on-click="onCreatePagePlot"
      :block="!pagePlots.length"
      :disabled="isLookupDataLoading"
    />
    <asc-label
      v-if="!pagePlots.length"
      value="You currently have no plots in your Plots Editor. Click Create New Plot to start building."
      class="noPlotsMsg"
      size="md"
      :color="getNoPlotsMsgColor"
    ></asc-label>
  </div>
</template>

<script>
import AscLabel from '@/components/atoms/AscLabel'
import AscAccentButton from '@/components/atoms/AscAccentButton'
import variables from '@/styles/_varsJs.scss'

export default {
  name: 'AscCreatePlotWrapper',

  components: {
    AscAccentButton,
    AscLabel,
  },

  props: {
    pagePlots: {
      type: Array,
      default: () => [],
    },
    onCreatePagePlot: {
      type: Function,
      default: () => {},
    },
    isLookupDataLoading: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    getNoPlotsMsgColor() {
      return variables.gray700
    },
  },
}
</script>

<style lang="scss">
.asc-create-plot-wrapper {
  margin-top: 16px;

  .asc-accent-button-container {
    height: auto;

    .asc-accent-button--accent {
      &.v-btn--block {
        min-height: 92px;
      }
    }
  }

  .asc-label.noPlotsMsg {
    margin: 52px 0 71px 0;
    line-height: 18px;
    text-align: center;
    display: block;
  }
}
</style>
